<div *ngFor="let validator of validators">
    <ng-container *ngIf="validatorValue[documentId] &&
                         validatorValue[documentId][fieldName] &&
                         validatorValue[documentId][fieldName][validator.name]">
        <div class="validator">
            <span class="mat-error" role="alert">
                {{ validator.text }}
            </span>
            <mat-icon class="ft-validation-icon-error mat-error"
                      attr.aria-hidden="false" 
                      [attr.aria-label]="validator.text">
                error
            </mat-icon>
        </div>
    </ng-container>
</div>
